<template>
  <message-incoming v-bind="{ ...$props, ...$attrs }" v-on="$listeners">
    <audio controls>{{ $t("fallbacks.audio_file") }}</audio>
  </message-incoming>
</template>

<script>
import exportedAttachmentMixin from "./exportedAttachmentMixin";
import MessageIncoming from "../MessageIncoming.vue";

export default {
  name: "MessageIncomingAudioExport",
  extends: MessageIncoming,
  mixins: [exportedAttachmentMixin],
  components: { MessageIncoming },
};
</script>

<style lang="scss">
@import "@/assets/css/chat.scss";
</style>
